import React from 'react'
import { useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { is } from '../../components/MediaQuery'
import Button from '../../components/Template/Button'
import { driver } from '../../database/localStorage'
import { CredentialsStorage } from '../../database/localStorage/names'
import { getPanelUrlForEnv } from '../../utils/ApiUrl'
import { Mixpanel } from '../../utils/Mixpanel'
import styled from '../../theme'
import UpgradePremiumModal from '../../components/UpgradePremiumModal'
import useIsScope from '../../hooks/useIsScope'
import { PermissionScope } from '../Employees'
import { fireToastError } from '../../actions/toasts/fireToast'
import { useDispatch } from 'react-redux'

const Title = styled.div`
  color: #000;
  margin-bottom: 8px;
  text-align: center;
  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 157.143% */
  letter-spacing: 0.028px;
`

const Subtitle = styled.div`
  color: #000;

  text-align: center;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 163.636% */
  letter-spacing: 0.022px;
  margin-bottom: 32px;
`

function redirect() {
  const key = driver.getItem(CredentialsStorage.AccessToken, '')
  Mixpanel.track('Premium Active Screen Extend Access', {})
  //var EnvUrl = getApiUrlForEnv()
  window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
}

function UpgradePremiumBlockScreenModal({
  open,
  close,
}: UpgradePremiumBlockScreenModalProps &
  UpgradePremiumBlockScreenModalDispatch) {
  const isDesktop = is.desktop()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleClick = () => {
    if (!scopes.premium) {
      dispatch(fireToastError(t('BED_3621_no_permission')))
    } else {
      redirect()
    }
  }

  const scopes = useIsScope({
    premium: [PermissionScope.SCOPE_CAN_BUY_PREMIUM],
  })
  return (
    <UpgradePremiumModal
      open={open}
      close={close}
      buttons={
        <Button
          style={{
            width: '100%',
            padding: '4px',
            borderRadius: '6px',
            height: '40px',
            maxWidth: '280px',
          }}
          disabled={!scopes.premium}
          primary={true}
          onClick={handleClick}
        >
          {t('new_premium_access_denied_screen_button_text')}
        </Button>
      }
    >
      <Flex
        full={true}
        row={isDesktop}
        column={!isDesktop}
        style={{ minHeight: isDesktop ? '420px' : 'unset' }}
      >
        <div
          style={{
            position: 'absolute',
            top: '50%',
            right: '50%',
            transform: 'translate(50%,-100%)',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="103"
            height="103"
            viewBox="0 0 103 103"
            fill="none"
          >
            <g clip-path="url(#clip0_403_90797)">
              <path
                d="M77.2474 34.3307H72.9557V25.7474C72.9557 13.9024 63.3424 4.28906 51.4974 4.28906C39.6524 4.28906 30.0391 13.9024 30.0391 25.7474V34.3307H25.7474C21.0266 34.3307 17.1641 38.1932 17.1641 42.9141V85.8307C17.1641 90.5516 21.0266 94.4141 25.7474 94.4141H77.2474C81.9682 94.4141 85.8307 90.5516 85.8307 85.8307V42.9141C85.8307 38.1932 81.9682 34.3307 77.2474 34.3307ZM51.4974 72.9557C46.7766 72.9557 42.9141 69.0932 42.9141 64.3724C42.9141 59.6516 46.7766 55.7891 51.4974 55.7891C56.2182 55.7891 60.0807 59.6516 60.0807 64.3724C60.0807 69.0932 56.2182 72.9557 51.4974 72.9557ZM64.8016 34.3307H38.1932V25.7474C38.1932 18.4086 44.1586 12.4432 51.4974 12.4432C58.8361 12.4432 64.8016 18.4086 64.8016 25.7474V34.3307Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_403_90797">
                <rect width="103" height="103" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <Flex column={true} style={{ width: isDesktop ? '50%' : '100%' }}>
          <div>
            <Title>
              <span aria-label={'lock'} role={'img'}>
                🔒
              </span>{' '}
              {t('new_premium_access_denied_screen_header')}
            </Title>
            <Subtitle>{t('new_premium_access_denied_screen_text')}</Subtitle>
          </div>
        </Flex>
      </Flex>
    </UpgradePremiumModal>
  )
}

export default UpgradePremiumBlockScreenModal

export interface UpgradePremiumBlockScreenModalProps {
  open?: boolean
}

export interface UpgradePremiumBlockScreenModalDispatch {
  close?: () => void
}
